import React from 'react';
import { DebugPanelProvider } from '@rsos/debug-panel';
import { useFlag } from '@rsos/flags';
import panels from './panels';

export const DebugPanelGate: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const isEnabled = useFlag('debug-panel');
  return (
    <DebugPanelProvider panels={isEnabled ? panels : []}>
      {children}
    </DebugPanelProvider>
  );
};
